import React from 'react';

export default function UserPrivacy() {
  return (
    <div style={{ 
      display: 'flex', 
      background: '#020617', 
      minHeight: '100vh', 
      color: 'white',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '40px'
    }}>
      <div style={{ maxWidth: '800px', lineHeight: '1.6' }}>
        <h1>Privacy Policy</h1>
        
        <p style={{ marginTop: '20px' }}>
          <strong>Last updated:</strong> April 2025
        </p>

        <h3 style={{ marginTop: '25px', color: '#38bdf8' }}>Information We Collect</h3>
        <p>
          WWMMCGC collects basic account information including email address,
          profile details, and gaming statistics. We use Supabase for secure data storage.
        </p>

        <h3 style={{ marginTop: '25px', color: '#38bdf8' }}>How We Use Your Data</h3>
        <p>
          Your information is used solely for app functionality - displaying
          your profile, tracking game stats, and enabling social features like following.
        </p>

        <h3 style={{ marginTop: '25px', color: '#38bdf8' }}>Data Security</h3>
        <p>
          We implement industry-standard security measures. Your data is encrypted
          and never sold to third parties.
        </p>

        <h3 style={{ marginTop: '25px', color: '#38bdf8' }}>Contact</h3>
        <p>
          Questions? Email us at: <strong>support@wwmmcgc.com</strong>
        </p>
      </div>
    </div>
  );
}